export const EXTERNAL_URLS = {
  CCR_ADMIN_DASHBOARD: `${import.meta.env.VITE_CCR_URL}/admin`,
  CCR_LEARNER: import.meta.env.VITE_CCR_URL,
  BRIGHTPATH_HOME: import.meta.env.VITE_BRIGHTPATH_HOME_URL,
  DISCOVERY: import.meta.env.VITE_DISCOVERY_URL,
  CDN_BASE: import.meta.env.VITE_CDN_BASE_URL,
} as const;

export const CCR_VIDEO_URL = `${EXTERNAL_URLS.CDN_BASE}/public/ecp/ccr-overview-video.mp4`;
export const CCR_OPT_IN_FORM_URL = 'https://forms.gle/h8mmJqPzts94wAkJ8';
